<template>
  <div class="px-3">
    <zt-tab>
      <zt-tab-item
        :label="$t('message.selfService.infoEmployee.tab.personalData')"
      >
        <employee-personal-info
          :employeeState="employeeState"
          :country="country"
          :emailChange="emailChange"
        />
      </zt-tab-item>
      <zt-tab-item
        v-if="hasSelfService"
        :label="$t('message.selfService.infoEmployee.tab.contactData')"
      >
        <employee-contact-info :readonly="isReadOnly" />
      </zt-tab-item>
      <zt-tab-item
        v-if="hasSelfService"
        :label="$t('message.selfService.infoEmployee.tab.addressData')"
      >
        <employee-address-info :readonly="isReadOnly" />
      </zt-tab-item>
      <zt-tab-item
        v-if="hasSelfService"
        :label="$t('message.selfService.infoEmployee.tab.identificationData')"
      >
        <employee-identify-info :readonly="isReadOnly" />
      </zt-tab-item>
      <zt-tab-item
        v-if="hasSelfService"
        :label="$t('message.selfService.infoEmployee.tab.bankData')"
      >
        <employee-bank-info :readonly="isReadOnly" />
      </zt-tab-item>
    </zt-tab>
  </div>
</template>

<script>
import EmployeeIdentifyInfo from './profile/EmployeeIdentifyInfo'
import EmployeeBankInfo from './profile/EmployeeBankInfo'
import EmployeeContactInfo from './profile/EmployeeContactInfo'
import EmployeePersonalInfo from './profile/EmployeePersonalInfo'
import EmployeeAddressInfo from './profile/EmployeeAddressInfo'
import { mapGetters } from 'vuex'
import SichernIntegration from '@/apiClient/SichernIntegration'
export default {
  components: {
    EmployeeIdentifyInfo,
    EmployeeBankInfo,
    EmployeeContactInfo,
    EmployeePersonalInfo,
    EmployeeAddressInfo
  },
  props: {
    employeeState: 0,
    country: '',
    emailChange: ''
  },
  computed: {
    ...mapGetters({
      isActionAllowed: 'isActionAllowed'
    }),
    hasSelfService() {
      return this.isActionAllowed(200)
    },
    isReadOnly() {
      return this.hasVPI === true
    }
  },
  data() {
    return {
      VpService: new SichernIntegration(),
      hasVPI: false
    }
  },
  async created() {
    await this.checkActiveSichernPeopleIntegration()
  },
  methods: {
    checkActiveSichernPeopleIntegration() {
      const type = 'VP_ONBOARDING'
      this.VpService
        .checkIntegrationSichernPeopleByType(type)
        .then((res) => {
          this.hasVPI = res.data.data.enabled;
        })
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .zt-tab--ul {
  padding: 0 1rem !important;
}
::v-deep .zt-tab--li {
  background-color: white;
  overflow: hidden;
}
::v-deep .zt-input-main {
  font-size: 1.2rem;
}
::v-deep .zt-label {
  font-size: 16px;
}
::v-deep .zt-select-label {
  font-size: 16px;
}
::v-deep .zt-input-disabled .zt-input-slot .zt-label[data-v-aea3bcaa] {
  color: #969696;
}
</style>
